import { RedoCheckbox } from "@redotech/arbiter/checkbox/redo-checkbox";
import { CombineDiscountWith } from "./combine-discount-with-field";

/**
 * BigCommerce only exposes a single "combines with other promotions" boolean,
 * so this toggle collapses the three Shopify-style subfields into one.
 */
export function BigcommerceCombineDiscountField({
  value,
  setValue,
}: {
  value: CombineDiscountWith;
  setValue: (value: CombineDiscountWith) => void;
}) {
  const combinesWithOthers =
    value.orderDiscounts || value.productDiscounts || value.shippingDiscount;

  return (
    <RedoCheckbox
      label="Combine with other discounts"
      setValue={(checked) => {
        const enabled = checked === true;
        setValue({
          orderDiscounts: enabled,
          productDiscounts: enabled,
          shippingDiscount: enabled,
        });
      }}
      size="xs"
      value={combinesWithOthers}
    />
  );
}
